import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL, DEFAULT_PER_PAGE } from '../../utilities/constants';
import { handleApiCall } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const AddModule = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const {
        setNewNotification,
        setShowNotification,
        addNotification,
        setSegmentTitle,
        addToastMessage,
    } = useUI();

    const initialValues = {
        moduleName: "",
    };
    const validationSchema = Yup.object().shape({
        moduleName: Yup.string().required('Module Name is required'),
    });

    const handleAddModules = async (value) => {
        setLoading(true);
        try {
            const payload = {
                moduleName: value.moduleName,
            };

            const response = await handleApiCall(API_BASE_URL + "/api/1.0.0/modules", {
                method: "POST",
                body: payload,
            });

            if (response?.result?.responseCode === 200) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully created a Module, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully created a Module!",
                    status: true,
                    archive: false,
                });
                navigate(`/modules?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating a Module. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            setShowNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while creating a Module.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setSegmentTitle("Add Module");
    }, []);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}


            onSubmit={handleAddModules}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                    <div>
                        <label className="block text-sm font-medium mb-1">Module Name</label>
                        <Field
                            name="moduleName"
                            type="text"
                            placeholder='Eg: Fx Corridors.'
                            className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                ? "border-red-500 focus:ring-red-300"
                                : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                }`}
                        />
                        {errors.moduleName && touched.moduleName && (
                            <p className="text-xs text-red-500 mt-1">{errors.moduleName}</p>
                        )}
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/modules'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};
export default AddModule;


